module.exports = __webpack_public_path__ + "img/join_02.83ca63e9.jpg";